import * as React from "react";
import { useEffect } from "react";
import { Spinner } from "components/common";
import { useStore } from "stores/connect";
import { EventNotificationsActions, EventNotificationsStore } from "stores/event-notifications/EventNotificationsStore";
import LegacyNotificationForm from "./LegacyNotificationForm";
const LegacyNotificationFormContainer = ({ ...props }) => {
  useEffect(() => {
    EventNotificationsActions.listAllLegacyTypes();
  }, []);
  const { allLegacyTypes } = useStore(EventNotificationsStore);
  if (!allLegacyTypes) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading legacy notification information..." }));
  }
  return /* @__PURE__ */ React.createElement(LegacyNotificationForm, { ...props, legacyTypes: allLegacyTypes });
};
export default LegacyNotificationFormContainer;
